import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape, propFunc, propBool, propOneOf, } from '../../../../helpers/custom-prop-types';
import ProfessionalUnitCompanyContact from './Company/ProfessionalUnitCompanyContact';
import ProfessionalUnitCompanyInformation from './Company/ProfessionalUnitCompanyInformation';
const ProfessionalUnitRightContent = (props) => {
    const { isSubscribed, onChangeSubscribe, onClickContact, onClickIntroduction, showAlertModal, showSubscribeModal, unit, userMode, } = props;
    return (_jsx("div", Object.assign({ className: 'content_right' }, { children: _jsxs("div", Object.assign({ className: 'unit_company' }, { children: [_jsx(ProfessionalUnitCompanyContact, { isSubscribed: isSubscribed, onChangeSubscribe: onChangeSubscribe, onClickContact: onClickContact, onClickIntroduction: onClickIntroduction, showAlertModal: showAlertModal, showSubscribeModal: showSubscribeModal, unit: unit, userMode: userMode }), _jsx(ProfessionalUnitCompanyInformation, { unit: unit })] })) })));
};
ProfessionalUnitRightContent.propTypes = {
    isSubscribed: propBool().isRequired,
    onChangeSubscribe: propFunc().isRequired,
    onClickContact: propFunc().isRequired,
    onClickIntroduction: propFunc().isRequired,
    showAlertModal: propFunc().isRequired,
    showSubscribeModal: propFunc().isRequired,
    unit: propShape().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
export default ProfessionalUnitRightContent;
